import { useCustomUpdateJobPhaseCostingMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateJobPhaseCosting() {
  const [mutation, { loading, data, error }] = useCustomUpdateJobPhaseCostingMutation({
    refetchQueries: ["getJobPhase", "customGetJobPhase", "customGetJobPhaseCostItem"],
  });

  const [updateJobPhaseCosting, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateJobPhaseCosting",
    },
    {
      hideMessage: true,
    }
  );

  return [updateJobPhaseCosting, context] as const;
}
